import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Applicant } from '@app/models/recruiting/applicant.model';

@Component({
    templateUrl: './comments.template.html',
})
export class CommentsComponent implements OnInit {
    applicant = new Applicant();
    constructor(private route: ActivatedRoute) {}

    async ngOnInit(): Promise<void> {
        this.applicant = this.route.parent.snapshot.data.models.get('applicant');
    }
}
